import { render, staticRenderFns } from "./SensorDetail.vue?vue&type=template&id=7a54d7ec"
import script from "./SensorDetail.vue?vue&type=script&lang=ts"
export * from "./SensorDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports